import React from 'react';
import {Link} from 'react-router';
import { I18n, Trans } from 'react-i18next';



export class NavItem extends React.Component {

  render() {
    return (
      <I18n ns="translations">
        {
          (t, { i18n }) => (
   
               <div>
                    <ul className="nav navbar-nav" id="head-navbar">
                      <li className="active"><a href="index.html">Home</a><span className="active-circle"></span> </li>
                      <li><a href="#">Blog</a> </li>
                      <li><Link to="propos">{t('about')}</Link></li> 
                      <li><Link to="pros">{t('professionel')}</Link></li> 
                    </ul>
                    <ul className="nav navbar-nav navbar-right">
                      <li className="dropdown dropdown-select " id="country-link">
                        <button className="btn btn-default dropdown-toggle " type="button" id="dropdownMenu1" data-toggle="dropdown" aria-expanded="true">
                            <img src={t('url')}/>
                        </button>
                        <ul className="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1">
                            <li role="presentation"><a className="img-link" role="menuitem" tabIndex="-1" href="#"  onClick={() => i18n.changeLanguage('fr')}><img src="../../images/header_dd_fr.png"/></a></li>
                            <li role="presentation"><a className="img-link" role="menuitem" tabIndex="-1" href="#"  onClick={() => i18n.changeLanguage('en')}><img src="../../images/header_dd_eng.png"/></a></li>
                        </ul>
                      </li>
                    </ul>
               </div>
            )
         }
     </I18n>
     
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Nav/NavItem.js